import React from 'react'
import { Content, Field } from '../styles'

import { FaMagnifyingGlass, FaGlobe } from 'react-icons/fa6'

export interface SearchInputProps {
  onSearch: (search: string) => void
  onGlobalSearch?: (search: string) => void
  isLoading: boolean
  background?: string
  placeholder: string
  showGlobalSearch?: boolean
}

const SearchInput: React.FunctionComponent<SearchInputProps> = ({
  onSearch,
  onGlobalSearch,
  placeholder,
  background,
  showGlobalSearch = false,
}) => {
  const [searchPayload, setSearchPayload] = React.useState('')

  const handleChangeText = (value: string) => {
    setSearchPayload(value)
  }

  const _handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): any => {
    if (e.key === 'Enter') {
      e.preventDefault()

      if (e.ctrlKey && onGlobalSearch) {
        // Ctrl + Enter para busca global
        onGlobalSearch(searchPayload)
      } else {
        // Enter normal para busca local
        onSearch(searchPayload)
      }
    }
  }

  const handleGlobalSearch = () => {
    if (onGlobalSearch) {
      onGlobalSearch(searchPayload)
    }
  }

  return (
    <Content background={background}>
      <FaMagnifyingGlass size={25} />
      <Field
        background={background}
        onChange={({ target }) => handleChangeText(target.value)}
        placeholder={placeholder}
        onKeyDown={_handleKeyDown}
        error={false}
        value={searchPayload}
        type='text'
      />
      {showGlobalSearch && onGlobalSearch && (
        <button
          type="button"
          onClick={handleGlobalSearch}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#666',
            fontSize: '16px'
          }}
          title="Busca global (Ctrl + Enter)"
        >
          <FaGlobe size={20} />
        </button>
      )}
    </Content>
  )
}

export default SearchInput
